import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../header';
import Footer from '../footer';
import './index.less';
import Navs from '../navs';

/**
 *
//                            _ooOoo_
//                           o8888888o
//                           88" . "88
//                           (| -_- |)
//                            O\ = /O
//                        ____/`---'\____
//                      .   ' \\| |// `.
//                       / \\||| : |||// \
//                     / _||||| -:- |||||- \
//                       | | \\\ - /// | |
//                     | \_| ''\---/'' | |
//                      \ .-\__ `-` ___/-. /
//                   ___`. .' /--.--\ `. . __
//                ."" '< `.___\_<|>_/___.' >'"".
//               | | : `- \`.;`\ _ /`;.`/ - ` : | |
//                 \ \ `-. \_ __\ /__ _/ .-` / /
//         ======`-.____`-.___\_____/___.-`____.-'======
//                            `=---='
//
//         .............................................
//                  佛祖镇楼                  BUG辟易
//          佛曰:
//                  写字楼里写字间，写字间里程序员；
//                  程序人员写程序，又拿程序换酒钱。
//                  酒醒只在网上坐，酒醉还来网下眠；
//                  酒醉酒醒日复日，网上网下年复年。
//                  但愿老死电脑间，不愿鞠躬老板前；
//                  奔驰宝马贵者趣，公交自行程序员。
//                  别人笑我忒疯癫，我笑自己命太贱；
//                  不见满街漂亮妹，哪个归得程序员？
 */
class Jobs extends Component {
    constructor(props, context) {
        super(props, context);

    }
    state = {job: '', company: ''}

	  componentDidMount() {
	    this.props.loadData && this.props.loadData(this.state.company);
          this.state.job = "5bdbb771c5a7866b7fd6d020";
	  }
	
	  filterJobs(companyId) {
	    this.setState({
	      company: companyId
	    }, () => {
	      this.props.loadData(companyId)
	    })
	  }
	
	  handleJobShow(id) {
	    let _id = this.state.job === id ? '' : id;
	    this.setState({job: _id})
	  }
    render() {
        var me = this, jobs = [], companies = [];
	    var props = this.props;

	    console.log(me)
	    console.log(props)
	    if (props.JobList.length && props.CateList.length) {
	      jobs = props.JobList;
	      companies = props.CateList;

	    }
        return (
            <div className="jobs">
                {/* <Header /> */}
                <Navs selector=".box-slide"/>
                <div className="jobs__wrapper1">
                    
                </div>
                <div className="jobs__wrapper12">
                    <div className="jobs__wrapper12-con">
                        <a href="#a1">企业介绍</a>
                        <a href="#a2">福利待遇</a>
                        <a href="#a3">招聘对象</a>
                        <a href="#a4">招聘岗位</a>
                        <a href="#a5">招聘条件</a>
                        <a href="#a6">招聘流程</a>
                        <a href="#a7">注意事项</a>
                    </div>
                </div>
                <div className="jobs__wrapper2 box-slide">
                    <div className="tit" name="a1" id="a1">企业介绍</div>
                    <div className="jobs__wrapper2-con">
                        <p>重庆三峡银行股份有限公司是经中国银监会批准成立的城市商业银行，是重庆市市属国有重点企业，注册资本55.74亿元。截至2017年末，全行资产总额达2023.61亿元、各项存款余额1238.00亿元、各项贷款总额443.47亿元，各项监管指标全面达到审慎监管要求。全行员工总数2156人，营业网点86个，覆盖全重庆市各个区县。</p>
                        <p>重庆三峡银行始终秉持“一切为你着想”的服务理念，坚持中小企业银行、零售银行、理财银行、库区银行四大战略定位，坚定综合化、特色化、差异化、精细化、专业化发展道路，2017年跻身全球银行500强，在英国《银行家》杂志公布的全球1,000家银行排名中位列第474位，在中国银行业协会发布的中国前100家银行位列第75位。</p>
                        <p>多年来，重庆三峡银行积极投身地方建设，先后荣获“全国五一劳动奖状”“重庆市五一劳动奖状”“全国银行业金融机构小微企业金融服务先进单位”“中国最佳中小企业金融服务机构”“中国地方金融十佳服务小微企业银行”“全国服务中小企业发展十佳商业银行”“中国地方金融十佳成长银行” “社会责任民生服务奖”“社会责任特殊贡献奖”“重庆企业100强”“重庆企业效益50佳”“重庆市纳税50强”等荣誉。</p>
                    </div>
                </div>
                <div className="jobs__wrapper3 box-slide">
                    <div className="tit" name="a2" id="a2">福利待遇</div>
                    <div className="jobs__wrapper3-con">
                        <p>1．薪酬：有竞争力的薪酬；</p>
                        <p>2．健康关怀：年度健康体检；</p>
                        <p>3．福利：五险一金、商业保险、职工互助保障、生日关怀、带薪年假、工作餐；</p>
                        <p>4．培训：丰富多彩的入职培训、线上线下培训；</p>
                        <p>5．职业通道：广阔的发展平台、公平的晋升机会、畅通的晋升通道。</p>
                    </div>
                </div>
                <div className="jobs__wrapper4 box-slide">
                    <div className="tit" name="a3" id="a3">招聘对象</div>
                    <div className="jobs__wrapper4-con">
                        <div className="jobs__wrapper4-bg1">
                            2019年应届毕业生，管理培训生针对全日制硕士研究生及以上学历，信息科技人员针对全日制本科以上学历。报到时需获得毕业证和学位证。
                        </div>
                        <div className="jobs__wrapper4-bg2">
                            2018年7月至2019年7月毕业，初次就业的海外院校留学归国学生，硕士研究生及以上学历，且获得教育部学历认证。
                        </div>
                    </div>
                </div>
                <div className="jobs__wrapper5 box-slide">
                    <div className="tit" name="a4" id="a4">招聘岗位</div>
                    <div className="list">
                        <div className="jobtit"></div>
		           		 {
			                jobs.map(job => {
							  return (
								  <div className={me.state.job == job.id ? 'act' : ''} >
									  <ul className="job" key={job.id} onClick={() => me.handleJobShow(job.id)}>
										  <li className="f">{job.name}</li>
										  <li className="r">{job.recruitNumber}</li>
										  <li className="z"><a target="_blank"
															  href={"http://applyjob.chinahr.com/apply/job/wish?jobId=" + job.id}>Apply</a></li>
										  {/* <li className="d"></li> */}
										  {/* <li className="l">详情<img src={me.state.job == job.id ? Open : Close }/></li> */}
									  </ul>
									  
								  </div>
							  )

			                })
			              }
		            </div>
                </div>
                <div className="jobs__wrapper6 box-slide">
                    <div className="tit" name="a5" id="a5">招聘条件</div>
                    <div className="jobs__wrapper6-con">
                    <p>1．本科阶段、研究生阶段主修经济金融类、金融数学类、工商管理类、软件工程类、计算机类、汉语言文学类等相关专业；</p>
                    <p>2．通过大学英语六级（CET-6）考试，或托业（TOEIC）听读公开考试715分及以上，或新托福（TOEFL-IBT）考试85分及以上，或雅思（IELTS）考试6分及以上；</p>
                    <p>3．诚实守信，身心健康，形象气质佳，具有较强的事业心、责任感和团队合作精神，有良好的学习能力、沟通能力、文字综合能力，无违规违纪等不良记录；</p>
                    <p>4．具有CPA、ACCA、CFA或相关资格者，通过司法考试者优先；</p>
                    <p>5．在校期间有一定的学术、科研成果，有相关金融机构实习经历者优先。</p>
                    </div>
                </div>
                <div className="jobs__wrapper7 box-slide">
                    <div className="tit" name="a6" id="a6">招聘流程</div>
                    <div className="jobs__wrapper7-con"></div>
                </div>
                <div className="jobs__wrapper8 box-slide">
                    <div className="tit" name="a7" id="a7">注意事项</div>
                    <div className="jobs__wrapper8-con">
                        <p>1．请登录网站进行简历投递：http://chrcmp.chinahr.com/pages/cqsx/</p>
                        <p>2．简历接收截止时间：2018年11月22日；</p>
                        <p>3．招聘各环节，我行会通过短信、邮件、电话等方式与您联系，请您在简历中写明您稳定的联系方式，并保持您联系方式的畅通；</p>
                        <p>4．请确保您所提交简历的真实性，一旦发现信息虚假者，我们将取消其应聘资格；</p>
                        <p>5．我行的面试地点分别为北京和重庆两地，请根据您的安排选择您的面试地址；</p>
                        <p>6．我行在校园招聘的任何环节均不会以任何形式收取费用，谨防上当受骗。</p>
                    </div>
                    <div className="jobs__wrapper8-under">
                        <a target="_blank" href="http://www.ccqtgb.com">重庆三峡银行官网：http://www.ccqtgb.com</a>
                    </div>
                </div>
                <Footer />

            </div>
        );
    }
}

/**
 * List对外提供属性
 */
Jobs.propTypes = {
    loadData: PropTypes.func
}

export default Jobs;


// WEBPACK FOOTER //
// ./_source/cqsx/pages/cqsx/cmps/jobs/index.js